export default {
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      confirmedPassword: "",
      emailRules: [
        v => !!v || "email is required",
        v => /.+@.+/.test(v) || "email must be valid"
      ],
      passwordRules: [
        v => !!v || "password is required",
        v => v.length >= 6 || "minimum 6 characters",
        v =>
          /0/.test(v) ||
          /1/.test(v) ||
          /2/.test(v) ||
          /3/.test(v) ||
          /4/.test(v) ||
          /5/.test(v) ||
          /6/.test(v) ||
          /7/.test(v) ||
          /8/.test(v) ||
          /9/.test(v) ||
          "password must include a number",
        v =>
          /a/.test(v) ||
          /b/.test(v) ||
          /c/.test(v) ||
          /d/.test(v) ||
          /e/.test(v) ||
          /f/.test(v) ||
          /g/.test(v) ||
          /h/.test(v) ||
          /i/.test(v) ||
          /j/.test(v) ||
          /k/.test(v) ||
          /l/.test(v) ||
          /m/.test(v) ||
          /n/.test(v) ||
          /o/.test(v) ||
          /p/.test(v) ||
          /q/.test(v) ||
          /r/.test(v) ||
          /s/.test(v) ||
          /t/.test(v) ||
          /u/.test(v) ||
          /v/.test(v) ||
          /w/.test(v) ||
          /x/.test(v) ||
          /y/.test(v) ||
          /z/.test(v) ||
          "password must include a lowercase letter"
      ]
    };
  },
  computed: {
    comparePasswords() {
      if (this.password !== this.confirmedPassword) {
        return "passwords must match";
      } else {
        return true;
      }
    }
  }
};
